import { Best, Correct, Inaccuracies, Wrong, Blunders, Unknown } from '@/assets/icons/statistic'
import { MovesQuality, type SeatConfig } from '@/types'
import type { AcePokerTable } from '@acepoker/contract'

export const gameFormatList: {
  id: string
  label: string
  value: AcePokerTable['gaming_configuration']
  max_players: number
  factors: {
    sb: 0.5
    straddle: 2
    ante: 0.5
  }
}[] = [
  {
    id: 'nlhe-8-3+a',
    label: 'NLHE, 8-max, 3 blinds + Ante',
    value: {
      game: 'NLHE',
      blinds: [50, 100, 200],
      antes: 50
    },
    max_players: 8,
    factors: {
      sb: 0.5,
      straddle: 2,
      ante: 0.5
    }
  }
  // {
  //   id: 'nlhe-8-2',
  //   label: 'NLHE, 8-max, 2 blinds',
  //   value: {
  //     game: 'NLHE',
  //     blinds: [50, 100],
  //     antes: 0
  //   },
  //   max_players: 8,
  //   factors: {
  //     sb: 0.5,
  //     straddle: 2,
  //     ante: 0.5
  //   }
  // }
  // {
  //   id: 'nlhe-8-2+a',
  //   label: 'NLHE, 8-max, 2 blinds + Ante',
  //   value: {
  //     game: 'NLHE',
  //     blinds: [50, 100],
  //     antes: 50
  //   },
  //   max_players: 8
  // },
  // {
  //   id: 'nlhe-8-3',
  //   label: 'NLHE, 8-max, 3 blinds',
  //   value: {
  //     game: 'NLHE',
  //     blinds: [50, 100, 200],
  //     antes: 0
  //   },
  //   max_players: 8
  // }
] as const

export const avatars = [
  { id: 1, background: '#A276E9', url: '/assets/bots/avatar1.png' },
  { id: 2, background: '#768FE9', url: '/assets/bots/avatar2.png' },
  { id: 3, background: '#76E982', url: '/assets/bots/avatar3.png' },
  { id: 4, background: '#76E9E2', url: '/assets/bots/avatar4.png' },
  { id: 5, background: '#E97676', url: '/assets/bots/avatar5.png' },
  { id: 6, background: '#E97676', url: '/assets/bots/avatar6.png' },
  { id: 7, background: '#767BE9', url: '/assets/bots/avatar7.png' },
  { id: 8, background: '#E9BB76', url: '/assets/bots/avatar8.png' },
  { id: 9, background: '#BDE976', url: '/assets/bots/avatar9.png' },
  { id: 10, background: '#A276E9', url: '/assets/bots/avatar10.png' }
] as const

export const emojis = [
  { id: 1, url: '/assets/emojis/human_kiss.png', name: 'Cyborg Kiss Emoji' },
  { id: 2, url: '/assets/emojis/human_like.png', name: 'Cybrog Likeparty Emoji' },
  { id: 3, url: '/assets/emojis/human_wink.png', name: 'Winking Emoji' },
  { id: 4, url: '/assets/emojis/human_surrender.png', name: 'Cyborg Surrender Emoji' },
  { id: 5, url: '/assets/emojis/human_cool.png', name: 'Cyborg Cool Emoji' },
  { id: 6, url: '/assets/emojis/human_sad.png', name: 'Cyborg Sad Emoji' },
  { id: 7, url: '/assets/emojis/human_anger.png', name: 'Anger Cybrog Emoji' },
  { id: 8, url: '/assets/emojis/human_smirk.png', name: 'Cyborg Smirking Emoji' },
  { id: 9, url: '/assets/emojis/human_shock.png', name: 'Cyborg Shock Emoji' },
  { id: 10, url: '/assets/emojis/human_humble.png', name: 'Cyborg Shy Emoji' },
  { id: 11, url: '/assets/emojis/human_crying.png', name: 'Cyborg Crying Emoji' },
  { id: 12, url: '/assets/emojis/human_laughing.png', name: 'Cybrog Laugh Emoji' }
] as const

export const BOTS_LIST = [
  {
    type: 'GTO',
    name: 'GTO',
    description: 'Clear actions; Minimal bluffing and aggression.',
    avatarId: 9,
    tag: 'AI',
    enabled: true
  },
  {
    type: 'TAG',
    name: 'TAG',
    description: 'Optimal AI with few bluffs and good game reading.',
    avatarId: 2,
    tag: 'AI'
  },
  {
    type: 'LAG',
    name: 'LAG',
    description: 'Clear actions; Minimal bluffing and aggression.',
    avatarId: 6,
    tag: 'AI'
  },
  // {
  //   type: 'FISH',
  //   name: 'FISH',
  //   description: 'Clear actions; Minimal bluffing and aggression.',
  //   avatarId: 9,
  //   tag: 'AI'
  // },
  {
    type: 'phil',
    name: 'Phil Ivey AI',
    description: 'A professional player; Good combinations and aggressive play.',
    avatar: '/assets/bots/avatar_phil_ivey.png',
    tag: 'AI'
  }
]

export const SEAT_COUNT = 9

const D_OWNER_ROW = 105
const D_OPPOSITE_OWNER_ROW = 0

const D_COLUMNS = [-6, -2, 15, 30, 50] as const
const D_ROWS = [0, 25, 70, 109, 117] as const

const desktopSeatConfig = [
  { top: D_ROWS[4], left: D_COLUMNS[4], mode: 'left', popupPlacement: 'top' },
  { top: D_ROWS[3], left: D_COLUMNS[2], mode: 'right', popupPlacement: 'top' },
  { top: D_ROWS[2], left: D_COLUMNS[0], mode: 'right', popupPlacement: 'right' },
  { top: D_ROWS[1], left: D_COLUMNS[1], mode: 'right', popupPlacement: 'bottom' },
  { top: D_ROWS[0], left: D_COLUMNS[3], mode: 'right', popupPlacement: 'bottom' },
  { top: D_ROWS[0], left: 100 - D_COLUMNS[3], mode: 'left', popupPlacement: 'bottom' },
  { top: D_ROWS[1], left: 96 - D_COLUMNS[1], mode: 'left', popupPlacement: 'left' },
  { top: D_ROWS[2], left: 97 - D_COLUMNS[0], mode: 'left', popupPlacement: 'top' },
  { top: D_ROWS[3], left: 100 - D_COLUMNS[2], mode: 'left', popupPlacement: 'top' }
] as const satisfies { length: typeof SEAT_COUNT }

const M_COLUMNS = [-2, 6, 30, 50] as const
const M_ROWS = [110, 95, 60, 30, 8]

const mobileSeatConfig = [
  { top: M_ROWS[0], left: M_COLUMNS[3], mode: 'left', popupPlacement: 'top' },
  { top: M_ROWS[1], left: M_COLUMNS[0], mode: 'left', popupPlacement: 'top' },
  { top: M_ROWS[2], left: M_COLUMNS[0], mode: 'left', popupPlacement: 'right' },
  { top: M_ROWS[3], left: M_COLUMNS[1], mode: 'left', popupPlacement: 'bottom' },
  { top: M_ROWS[4], left: M_COLUMNS[2], mode: 'right', popupPlacement: 'bottom' },
  { top: M_ROWS[4], left: 100 - M_COLUMNS[2], mode: 'right', popupPlacement: 'bottom' },
  { top: M_ROWS[3], left: 100 - M_COLUMNS[1], mode: 'right', popupPlacement: 'left' },
  { top: M_ROWS[2], left: 100 - M_COLUMNS[0], mode: 'right', popupPlacement: 'top' },
  { top: M_ROWS[1], left: 100 - M_COLUMNS[0], mode: 'right', popupPlacement: 'top' }
] as const satisfies { length: typeof SEAT_COUNT }

export const seatConfig = {
  desktop: desktopSeatConfig,
  mobile: mobileSeatConfig
}

const desktopDealerChipLocations = [
  { top: 95, left: 40 },
  { top: 95, left: 30 },
  { top: 72, left: 11 },
  { top: 39, left: 10 },
  { top: 14, left: 42 },
  { top: 14, left: 62 },
  { top: 39, left: 90 },
  { top: 72, left: 90 },
  { top: 95, left: 76 }
] as const satisfies { length: typeof SEAT_COUNT }

const mobileDealerChipLocations = [
  { top: 93, left: 60 },
  { top: 90, left: 18 },
  { top: 65.5, left: 13 },
  { top: 36, left: 20 },
  { top: 15, left: 42 },
  { top: 15, left: 58 },
  { top: 36, left: 80 },
  { top: 65.5, left: 87 },
  { top: 90, left: 71 }
] as const satisfies { length: typeof SEAT_COUNT }

export const dealerChipLocations = {
  desktop: desktopDealerChipLocations,
  mobile: mobileDealerChipLocations
} as const

const desktopChipCountsLocations = [
  { top: 80, left: 60 },
  { top: 80, left: 32 },
  { top: 52, left: 13 },
  { top: 24, left: 14 },
  { top: 10, left: 36 },
  { top: 10, left: 65 },
  { top: 24, left: 83 },
  { top: 52, left: 85 },
  { top: 80, left: 71 }
]

const mobileChipCountsLocations = [
  { top: 85, left: 47 },
  { top: 77, left: 16 },
  { top: 56, left: 10 },
  { top: 26, left: 20 },
  { top: 13, left: 26 },
  { top: 13, left: 65 },
  { top: 26, left: 71 },
  { top: 56, left: 80 },
  { top: 77, left: 80 }
]

export const chipCountsLocations = {
  desktop: desktopChipCountsLocations,
  mobile: mobileChipCountsLocations
}

export const actionIcons: Record<keyof typeof MovesQuality, string> = {
  best: Best,
  correct: Correct,
  inaccuracy: Inaccuracies,
  wrong: Wrong,
  blunder: Blunders,
  unknown: Unknown
}

// new positioning depends on players count

const D_GRID_ROWS = {
  8: [-4, 10, 55, 100, 117],
  9: [0, 25, 70, 109, 117]
} as const
const D_GRID_COLUMNS = {
  8: [-10, 2, 49],
  9: [-6, -2, 15, 30, 50]
} as const

const desktopSeatConfigByCount: Record<number, SeatConfig[]> = {
  2: [
    { top: D_GRID_ROWS[8][4], left: D_GRID_COLUMNS[8][2], mode: 'left', popupPlacement: 'top' },
    { top: D_GRID_ROWS[8][0], left: D_GRID_COLUMNS[8][2], mode: 'left', popupPlacement: 'bottom' }
  ],
  4: [
    { top: D_GRID_ROWS[8][4], left: D_GRID_COLUMNS[8][2], mode: 'left', popupPlacement: 'top' },
    { top: D_GRID_ROWS[8][2], left: D_GRID_COLUMNS[8][0], mode: 'right', popupPlacement: 'right' },
    { top: D_GRID_ROWS[8][0], left: D_GRID_COLUMNS[8][2], mode: 'left', popupPlacement: 'bottom' },
    {
      top: D_GRID_ROWS[8][2],
      left: 96 - D_GRID_COLUMNS[8][0],
      mode: 'left',
      popupPlacement: 'top'
    }
  ],
  6: [
    { top: D_GRID_ROWS[8][4], left: D_GRID_COLUMNS[8][2], mode: 'left', popupPlacement: 'top' },
    { top: D_GRID_ROWS[8][3], left: D_GRID_COLUMNS[8][1], mode: 'right', popupPlacement: 'top' },
    { top: D_GRID_ROWS[8][1], left: D_GRID_COLUMNS[8][1], mode: 'right', popupPlacement: 'bottom' },
    { top: D_GRID_ROWS[8][0], left: D_GRID_COLUMNS[8][2], mode: 'left', popupPlacement: 'bottom' },
    {
      top: D_GRID_ROWS[8][1],
      left: 96 - D_GRID_COLUMNS[8][1],
      mode: 'left',
      popupPlacement: 'left'
    },
    { top: D_GRID_ROWS[8][3], left: 96 - D_GRID_COLUMNS[8][1], mode: 'left', popupPlacement: 'top' }
  ],
  8: [
    { top: D_GRID_ROWS[8][4], left: D_GRID_COLUMNS[8][2], mode: 'left', popupPlacement: 'top' },
    { top: D_GRID_ROWS[8][3], left: D_GRID_COLUMNS[8][1], mode: 'right', popupPlacement: 'top' },
    { top: D_GRID_ROWS[8][2], left: D_GRID_COLUMNS[8][0], mode: 'right', popupPlacement: 'right' },
    { top: D_GRID_ROWS[8][1], left: D_GRID_COLUMNS[8][1], mode: 'right', popupPlacement: 'bottom' },
    { top: D_GRID_ROWS[8][0], left: D_GRID_COLUMNS[8][2], mode: 'left', popupPlacement: 'bottom' },
    {
      top: D_GRID_ROWS[8][1],
      left: 96 - D_GRID_COLUMNS[8][1],
      mode: 'left',
      popupPlacement: 'left'
    },
    {
      top: D_GRID_ROWS[8][2],
      left: 96 - D_GRID_COLUMNS[8][0],
      mode: 'left',
      popupPlacement: 'top'
    },
    { top: D_GRID_ROWS[8][3], left: 96 - D_GRID_COLUMNS[8][1], mode: 'left', popupPlacement: 'top' }
  ],
  9: [
    { top: D_GRID_ROWS[9][4], left: D_GRID_COLUMNS[9][4], mode: 'left', popupPlacement: 'top' },
    { top: D_GRID_ROWS[9][3], left: D_GRID_COLUMNS[9][2], mode: 'right', popupPlacement: 'top' },
    { top: D_GRID_ROWS[9][2], left: D_GRID_COLUMNS[9][0], mode: 'right', popupPlacement: 'right' },
    { top: D_GRID_ROWS[9][1], left: D_GRID_COLUMNS[9][1], mode: 'right', popupPlacement: 'bottom' },
    { top: D_GRID_ROWS[9][0], left: D_GRID_COLUMNS[9][3], mode: 'right', popupPlacement: 'bottom' },
    {
      top: D_GRID_ROWS[9][0],
      left: 100 - D_GRID_COLUMNS[9][3],
      mode: 'left',
      popupPlacement: 'bottom'
    },
    {
      top: D_GRID_ROWS[9][1],
      left: 96 - D_GRID_COLUMNS[9][1],
      mode: 'left',
      popupPlacement: 'left'
    },
    {
      top: D_GRID_ROWS[9][2],
      left: 97 - D_GRID_COLUMNS[9][0],
      mode: 'left',
      popupPlacement: 'top'
    },
    {
      top: D_GRID_ROWS[9][3],
      left: 100 - D_GRID_COLUMNS[9][2],
      mode: 'left',
      popupPlacement: 'top'
    }
  ]
} as const

const M_GRID_ROWS = {
  8: [110, 85, 53, 25, 8],
  9: [110, 95, 60, 30, 8]
}
const M_GRID_COLUMNS = {
  8: [0, 10, 30, 50],
  9: [-2, 6, 30, 50]
} as const

const mobileSeatConfigByCount: Record<number, SeatConfig[]> = {
  2: [
    { top: M_GRID_ROWS[8][0], left: M_GRID_COLUMNS[8][3], mode: 'left', popupPlacement: 'top' },
    { top: M_GRID_ROWS[8][4], left: M_GRID_COLUMNS[8][3], mode: 'right', popupPlacement: 'bottom' }
  ],
  4: [
    { top: M_GRID_ROWS[8][0], left: M_GRID_COLUMNS[8][3], mode: 'left', popupPlacement: 'top' },
    { top: M_GRID_ROWS[8][2], left: M_GRID_COLUMNS[8][0], mode: 'left', popupPlacement: 'right' },
    { top: M_GRID_ROWS[8][4], left: M_GRID_COLUMNS[8][3], mode: 'right', popupPlacement: 'bottom' },

    {
      top: M_GRID_ROWS[8][2],
      left: 100 - M_GRID_COLUMNS[8][0],
      mode: 'right',
      popupPlacement: 'top'
    }
  ],
  6: [
    { top: M_GRID_ROWS[8][0], left: M_GRID_COLUMNS[8][3], mode: 'left', popupPlacement: 'top' },
    { top: M_GRID_ROWS[8][1], left: M_GRID_COLUMNS[8][0], mode: 'left', popupPlacement: 'top' },
    { top: 40, left: 6, mode: 'left', popupPlacement: 'right' },
    { top: M_GRID_ROWS[8][4], left: M_GRID_COLUMNS[8][3], mode: 'right', popupPlacement: 'bottom' },
    {
      top: 40,
      left: 100 - 6,
      mode: 'right',
      popupPlacement: 'top'
    },
    {
      top: M_GRID_ROWS[8][1],
      left: 100 - M_GRID_COLUMNS[8][0],
      mode: 'right',
      popupPlacement: 'top'
    }
  ],
  8: [
    { top: M_GRID_ROWS[8][0], left: M_GRID_COLUMNS[8][3], mode: 'left', popupPlacement: 'top' },
    { top: M_GRID_ROWS[8][1], left: M_GRID_COLUMNS[8][0], mode: 'left', popupPlacement: 'top' },
    { top: M_GRID_ROWS[8][2], left: M_GRID_COLUMNS[8][0], mode: 'left', popupPlacement: 'right' },
    { top: M_GRID_ROWS[8][3], left: M_GRID_COLUMNS[8][1], mode: 'left', popupPlacement: 'bottom' },
    { top: M_GRID_ROWS[8][4], left: M_GRID_COLUMNS[8][3], mode: 'right', popupPlacement: 'bottom' },
    {
      top: M_GRID_ROWS[8][3],
      left: 100 - M_GRID_COLUMNS[8][1],
      mode: 'right',
      popupPlacement: 'left'
    },
    {
      top: M_GRID_ROWS[8][2],
      left: 100 - M_GRID_COLUMNS[8][0],
      mode: 'right',
      popupPlacement: 'top'
    },
    {
      top: M_GRID_ROWS[8][1],
      left: 100 - M_GRID_COLUMNS[8][0],
      mode: 'right',
      popupPlacement: 'top'
    }
  ],
  9: [
    { top: M_GRID_ROWS[9][0], left: M_GRID_COLUMNS[9][3], mode: 'left', popupPlacement: 'top' },
    { top: M_GRID_ROWS[9][1], left: M_GRID_COLUMNS[9][0], mode: 'left', popupPlacement: 'top' },
    { top: M_GRID_ROWS[9][2], left: M_GRID_COLUMNS[9][0], mode: 'left', popupPlacement: 'right' },
    { top: M_GRID_ROWS[9][3], left: M_GRID_COLUMNS[9][1], mode: 'left', popupPlacement: 'bottom' },
    { top: M_GRID_ROWS[9][4], left: M_GRID_COLUMNS[9][2], mode: 'right', popupPlacement: 'bottom' },
    {
      top: M_GRID_ROWS[9][4],
      left: 100 - M_GRID_COLUMNS[9][2],
      mode: 'right',
      popupPlacement: 'bottom'
    },
    {
      top: M_GRID_ROWS[9][3],
      left: 100 - M_GRID_COLUMNS[9][1],
      mode: 'right',
      popupPlacement: 'left'
    },
    {
      top: M_GRID_ROWS[9][2],
      left: 100 - M_GRID_COLUMNS[9][0],
      mode: 'right',
      popupPlacement: 'top'
    },
    {
      top: M_GRID_ROWS[9][1],
      left: 100 - M_GRID_COLUMNS[9][0],
      mode: 'right',
      popupPlacement: 'top'
    }
  ]
} as const

export const seatConfigByCount = {
  desktop: desktopSeatConfigByCount,
  mobile: mobileSeatConfigByCount
}

const desktopDealerChipLocationsByCount = {
  2: [
    { top: 93, left: 39 },
    { top: 11, left: 58 }
  ],
  4: [
    { top: 93, left: 39 },
    { top: 63, left: 7 },
    { top: 11, left: 58 },
    { top: 63, left: 100 - 7 }
  ],
  6: [
    { top: 93, left: 39 },
    { top: 93, left: 18 },
    { top: 20, left: 18 },
    { top: 11, left: 58 },
    { top: 20, left: 100 - 18 },
    { top: 93, left: 100 - 18 }
  ],
  8: [
    { top: 93, left: 42 },
    { top: 93, left: 18 },
    { top: 63, left: 7 },
    { top: 20, left: 18 },
    { top: 11, left: 58 },
    { top: 20, left: 100 - 18 },
    { top: 63, left: 100 - 7 },
    { top: 93, left: 100 - 18 }
  ],
  9: [
    { top: 95, left: 43 },
    { top: 95, left: 30 },
    { top: 72, left: 11 },
    { top: 39, left: 10 },
    { top: 14, left: 42 },
    { top: 14, left: 62 },
    { top: 39, left: 90 },
    { top: 72, left: 90 },
    { top: 95, left: 76 }
  ]
} as const

const mobileDealerChipLocationsByCount = {
  2: [
    { top: 96, left: 39 },
    { top: 16, left: 59 }
  ],
  4: [
    { top: 96, left: 39 },
    { top: 54, left: 18 },
    { top: 16, left: 59 },
    { top: 54, left: 100 - 18 }
  ],
  6: [
    { top: 96, left: 39 },
    { top: 86, left: 18 },
    { top: 36, left: 20 },
    { top: 16, left: 59 },
    { top: 36, left: 100 - 20 },
    { top: 86, left: 100 - 18 }
  ],
  8: [
    { top: 96, left: 39 },
    { top: 86, left: 18 },
    { top: 54, left: 18 },
    { top: 20, left: 25 },
    { top: 16, left: 40 },
    { top: 20, left: 100 - 25 },
    { top: 54, left: 100 - 18 },
    { top: 86, left: 100 - 18 }
  ],
  9: [
    { top: 96, left: 41 },
    { top: 90, left: 18 },
    { top: 65.5, left: 13 },
    { top: 36, left: 20 },
    { top: 13.5, left: 42 },
    { top: 13.5, left: 58 },
    { top: 36, left: 80 },
    { top: 65.5, left: 87 },
    { top: 90, left: 82 }
  ]
} as const

export const dealerChipLocationsByCount = {
  desktop: desktopDealerChipLocationsByCount,
  mobile: mobileDealerChipLocationsByCount
} as const

const desktopChipStackLocationsByCount = {
  2: [
    { top: 83, left: 56 },
    { top: 10, left: 40 }
  ],
  4: [
    { top: 83, left: 56 },
    { top: 46, left: 13 },
    { top: 10, left: 40 },
    { top: 46, left: 83 }
  ],
  6: [
    { top: 83, left: 56 },
    { top: 72, left: 24 },
    { top: 18, left: 22 },
    { top: 10, left: 40 },
    { top: 18, left: 74 },
    { top: 72, left: 72 }
  ],
  8: [
    { top: 80, left: 55 },
    { top: 72, left: 20 },
    { top: 46, left: 9 },
    { top: 18, left: 20 },
    { top: 7, left: 42 },
    { top: 18, left: 71 },
    { top: 46, left: 83 },
    { top: 72, left: 72 }
  ],
  9: [
    { top: 81, left: 55 },
    { top: 77, left: 21 },
    { top: 52, left: 9 },
    { top: 24, left: 13 },
    { top: 10, left: 28 },
    { top: 10, left: 67 },
    { top: 24, left: 78 },
    { top: 52, left: 83 },
    { top: 77, left: 77 }
  ]
} as const

const mobileChipStackLocationsByCount = {
  2: [
    { top: 90, left: 58 },
    { top: 20, left: 40 }
  ],
  4: [
    { top: 90, left: 58 },
    { top: 42, left: 20 },
    { top: 19, left: 46 },
    { top: 42, left: 71 }
  ],
  6: [
    { top: 90, left: 58 },
    { top: 71, left: 19 },
    { top: 39, left: 20 },
    { top: 19, left: 46 },
    { top: 39, left: 60 },
    { top: 71, left: 75 }
  ],
  8: [
    { top: 87, left: 42 },
    { top: 71, left: 11 },
    { top: 42, left: 12 },
    { top: 24, left: 21 },
    { top: 18, left: 46 },
    { top: 24, left: 58 },
    { top: 42, left: 67 },
    { top: 71, left: 69 }
  ],
  9: [
    { top: 90, left: 50 },
    { top: 77, left: 10 },
    { top: 50, left: 10 },
    { top: 26, left: 18 },
    { top: 15, left: 26 },
    { top: 15, left: 56 },
    { top: 26, left: 62 },
    { top: 50, left: 70 },
    { top: 77, left: 70 }
  ]
} as const

export const chipStackLocationsByCount = {
  desktop: desktopChipStackLocationsByCount,
  mobile: mobileChipStackLocationsByCount
} as const

// used for fake table
const desktopDealerChipLocationsByCountNoCards = {
  ...desktopDealerChipLocationsByCount,
  8: [
    { top: 95, left: 40 },
    { top: 93, left: 18 },
    { top: 63, left: 5 },
    { top: 20, left: 18 },
    { top: 11, left: 58 },
    { top: 20, left: 100 - 18 },
    { top: 63, left: 100 - 5 },
    { top: 93, left: 100 - 18 }
  ],
  9: [
    { top: 95, left: 44 },
    { top: 95, left: 30 },
    { top: 72, left: 11 },
    { top: 39, left: 10 },
    { top: 14, left: 42 },
    { top: 14, left: 62 },
    { top: 39, left: 90 },
    { top: 72, left: 90 },
    { top: 95, left: 76 }
  ]
} as const

const mobileDealerChipLocationsByCountNoCards = {
  ...mobileDealerChipLocationsByCount,
  8: [
    { top: 97, left: 45 },
    { top: 88, left: 17 },
    { top: 57, left: 14 },
    { top: 30, left: 20 },
    { top: 17, left: 55 },
    { top: 30, left: 100 - 20 },
    { top: 57, left: 100 - 14 },
    { top: 88, left: 100 - 17 }
  ],
  9: [
    { top: 93, left: 60 },
    { top: 90, left: 18 },
    { top: 65.5, left: 13 },
    { top: 36, left: 20 },
    { top: 15, left: 42 },
    { top: 15, left: 58 },
    { top: 36, left: 80 },
    { top: 65.5, left: 87 },
    { top: 90, left: 71 }
  ]
} as const

export const dealerChipLocationsByCountNoCards = {
  desktop: desktopDealerChipLocationsByCountNoCards,
  mobile: mobileDealerChipLocationsByCountNoCards
} as const

export const USER_RANK_LEVELS = [
  { title: 'Beginner', score_range: [0, 500] },
  { title: 'Hobbyist', score_range: [501, 1000] },
  { title: 'Amateur', score_range: [1001, 1500] },
  { title: 'Semi-Pro', score_range: [1501, 1800] },
  { title: 'Pro', score_range: [1801, 2200] },
  { title: 'Super-Pro', score_range: [2201, 2500] }
]

export const Round = {
  PREFLOP: 'preflop',
  FLOP: 'flop',
  TURN: 'turn',
  RIVER: 'river'
} as const
